module.exports = __webpack_public_path__ + "a8410c09baaedab5d8cad20b966562cd.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/heros/sublimation-hero.svg
// module id = 637
// module chunks = 0